import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

import { isProductionRuntime } from '@/lib/app-env';
import { ROUTES } from '@/lib/route-paths';

/**
 * Layout gate for the form-template builder. The whole surface runs on
 * fixtures (`features/form-templates/fixtures.ts` — no API, no persistence;
 * edits vanish on reload), so until the form engine's read/write services
 * land it must not be reachable in production. Same gate as the wireframe
 * trees; the nav entry is hidden via `hideInProduction` in
 * `lib/dashboard-nav.ts`, and this stops typed URLs and stale bookmarks.
 */
export const Route = createFileRoute(
  '/_authed/dashboard/settings/form-templates'
)({
  beforeLoad: () => {
    if (isProductionRuntime()) {
      throw redirect({ to: ROUTES.organisation });
    }
  },
  component: FormTemplatesLayout,
});

function FormTemplatesLayout() {
  return <Outlet />;
}
